module.exports = __webpack_public_path__ + "img/dump-truck.e63873e5.svg";